module.exports = __webpack_public_path__ + "static/img/img04.54c7ef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/img04.jpg
// module id = sGKx
// module chunks = 1